export const PUBLISHING_BLOCKED_NOTIFICATION = 'publishing-blocked';

export enum BlockerType {
  loki = 'loki',
  version = 'version',
}
